import React from 'react';
import { MessageCircle } from 'lucide-react';
export function FloatingWhatsApp() {
  return <a href="https://recetasexpress.store" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20bd5a] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group flex items-center justify-center" aria-label="Contact support on WhatsApp" data-id="element-60">
      <MessageCircle className="w-7 h-7" data-id="element-61" />

      {/* Tooltip */}
      <span className="absolute right-full mr-4 bg-white text-gray-800 text-sm font-bold py-2 px-4 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap" data-id="element-62">
        ¿Dudas? ¡Escríbenos!
        {/* Tooltip Arrow */}
        <span className="absolute top-1/2 -right-2 -translate-y-1/2 border-8 border-transparent border-l-white" data-id="element-63"></span>
      </span>

      {/* Pulse effect */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" data-id="element-64"></span>
    </a>;
}